import React, { useState } from "react";
import styles from "./ContextSelector.module.css";
import { FiPlus } from "react-icons/fi";

interface Context {
  id: string;
  name: string;
  description: string;
}

interface ContextSelectorProps {
  contexts: Context[];
  duplicateContextNameErr: string;
  setFormData: any;
  formData: any;
  setDuplicateNameErr: any;
}

const ContextSelector: React.FC<ContextSelectorProps> = (
  props: ContextSelectorProps
) => {
  const {
    contexts,
    duplicateContextNameErr,
    setFormData,
    formData,
    setDuplicateNameErr,
  } = props;

  const [showAddNew, setShowAddNew] = useState(false);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    setFormData({ ...formData, contextId: selectedId });
  };

  const shouldShowExistingContextSelector = !showAddNew && !!contexts.length;

  const ExistingContextSelector = (
    <div className={styles.selectContainer}>
      <select
        value={formData.contextId || ""}
        onChange={handleSelectChange}
        className={styles.select}
      >
        <option value="">Select a context...</option>
        {contexts.map((context) => (
          <option key={context.id} value={context.id}>
            {context.name}
          </option>
        ))}
      </select>

      {!formData.contextId && (
        <button
          className={styles.addNewButton}
          onClick={() => setShowAddNew(true)}
        >
          <FiPlus size={14} /> Add New Context
        </button>
      )}
    </div>
  );

  const AddNewContextForm = (
    <div className={styles.addNewForm}>
      <input
        type="text"
        value={formData.contextName}
        onChange={(e) => {
          const newContext = e.target.value.toLowerCase().trim();
          setFormData({ ...formData, contextName: newContext });
          setDuplicateNameErr("");
        }}
        placeholder="Context name"
        className={`${styles.input} ${
          duplicateContextNameErr ? styles.inputError : ""
        }`}
      />
      <input
        type="text"
        value={formData.contextDescription}
        onChange={(e) =>
          setFormData({ ...formData, contextDescription: e.target.value })
        }
        placeholder="Context description"
        className={styles.input}
      />
      {duplicateContextNameErr && (
        <div className={styles.errorMessage}>{duplicateContextNameErr}</div>
      )}
      <div className={styles.addNewActions}>
        <button
          className={styles.cancelButton}
          onClick={() => setShowAddNew(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  );

  return (
    <div className={styles.container}>
      {shouldShowExistingContextSelector
        ? ExistingContextSelector
        : AddNewContextForm}
    </div>
  );
};

export default ContextSelector;
